import { useEffect, useRef } from 'react'

/**
 * Imperatively sets the browser favicon, bypassing react-helmet-async.
 * Browsers treat favicons as singletons with aggressive caching —
 * Helmet's declarative diffing can race or skip updates.
 * This hook directly manipulates the DOM link element for reliable updates.
 */
export function useFavicon(href: string) {
  const prevHref = useRef<string | null>(null)

  useEffect(() => {
    if (href === prevHref.current) return
    prevHref.current = href

    let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }

    const ext = href.split('?')[0].split('.').pop()?.toLowerCase()
    const typeMap: Record<string, string> = {
      svg: 'image/svg+xml',
      png: 'image/png',
      ico: 'image/x-icon',
    }
    link.type = typeMap[ext ?? ''] ?? ''
    link.href = href
  }, [href])
}
